{
	"name": "@alexaegis/autotool-plugin-ts",
	"description": "TypeScript setup",
	"version": "0.15.6",
	"license": "MIT",
	"private": false,
	"archetype": {
		"platform": "node",
		"framework": "autotool",
		"language": "ts",
		"kind": "lib"
	},
	"keywords": [
		"autotool-plugin",
		"managed-by-autotool",
		"ts",
		"tsconfig",
		"typescript"
	],
	"repository": {
		"url": "git+https://github.com/AlexAegis/js-tooling.git",
		"type": "git"
	},
	"type": "module",
	"publishConfig": {
		"access": "public",
		"exports": {
			".": {
				"types": "./dist/index.d.ts",
				"import": "./dist/index.js",
				"require": "./dist/index.cjs",
				"default": "./dist/index.js"
			},
			"./package-composite-tsconfig": "./static/package-composite-tsconfig.json",
			"./package-simple-tsconfig": "./static/package-simple-tsconfig.json",
			"./package-spec-vitest-tsconfig": "./static/package-spec-vitest-tsconfig.json",
			"./package.json": "./package.json",
			"./readme": "./readme.md",
			"./workspace-tsconfig": "./static/workspace-tsconfig.json"
		}
	},
	"files": [
		"dist",
		"static"
	],
	"engines": {
		"node": ">=22.6.0"
	},
	"scripts": {
		"lint:depcheck": "turbo run lint:depcheck_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"lint:depcheck_": "depcheck",
		"lint:es": "turbo run lint:es_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"lint:es_": "eslint --max-warnings=0 --fix --no-error-on-unmatched-pattern .",
		"lint:format": "turbo run lint:format_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"lint:format_": "prettier --cache-location .cache/prettier --plugin prettier-plugin-svelte --plugin prettier-plugin-tailwindcss --check .",
		"lint:md": "turbo run lint:md_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"lint:md_": "remark --frail --no-stdout --silently-ignore .",
		"lint:tsc": "turbo run lint:tsc_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"lint:tsc_": "tsc --noEmit",
		"publint": "BUILD_REASON='publish' turbo run publint_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"publint_": "publint",
		"test": "turbo run test_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"test_": "vitest --passWithNoTests --coverage --run",
		"test:watch": "vitest --passWithNoTests --coverage",
		"all": "BUILD_REASON='publish' turbo run all_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"build": "turbo run build-lib_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"build-lib_": "vite build",
		"format": "turbo run format_ --concurrency 16 --filter @alexaegis/autotool-plugin-ts",
		"format_": "prettier --cache-location .cache/prettier --plugin prettier-plugin-svelte --plugin prettier-plugin-tailwindcss --write ."
	},
	"exports": {
		".": {
			"types": "./src/index.ts",
			"import": "./dist/index.js",
			"require": "./dist/index.cjs",
			"default": "./dist/index.js"
		},
		"./package-composite-tsconfig": "./static/package-composite-tsconfig.json",
		"./package-simple-tsconfig": "./static/package-simple-tsconfig.json",
		"./package-spec-vitest-tsconfig": "./static/package-spec-vitest-tsconfig.json",
		"./package.json": "./package.json",
		"./readme": "./readme.md",
		"./workspace-tsconfig": "./static/workspace-tsconfig.json"
	},
	"dependencies": {
		"@alexaegis/logging": "workspace:^",
		"@alexaegis/match": "workspace:^",
		"@alexaegis/predicate": "workspace:^",
		"@alexaegis/workspace-tools": "workspace:^",
		"autotool-plugin": "^0.8.0",
		"typescript": "^6.0.3"
	},
	"devDependencies": {
		"@alexaegis/eslint-config-vitest": "workspace:^",
		"@alexaegis/ts": "workspace:^",
		"@alexaegis/vite": "workspace:^",
		"@alexaegis/vitest": "workspace:^",
		"@types/node": "^26.1.1",
		"publint": "^0.3.21",
		"ts-node": "^10.9.2",
		"vite": "^8.1.4",
		"vite-plugin-dts": "^5.0.3",
		"vitest": "^4.1.10"
	}
}
